import Seo from './Seo'

/* Material */
import Container from '@mui/material/Container'
import Typo from '@mui/material/Typography'
import useStyles from './styles'

/* Material-Icons */
import CallIcon from '@mui/icons-material/Call'
import FaxIcon from '@mui/icons-material/Fax'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'

/* Shop-Config */
import shopInfos from 'template/infos'

/* Components */
import Kontaktformular from './Kontaktformular'
import StaticBreadcrumbs from 'src/components/Breadcrumbs/StaticBreadcrumbs'

/* Types */
import type { BreadcrumbItem } from 'src/shared/frontendTypes/product'

const breadcrumb: BreadcrumbItem[] = [
  { title: 'Kontakt' },
]

const Kontakt: React.FC = () => {
  const classes = useStyles()

  const { 
    legalname, street, postalcode, locality,
    telephone, fax, email,
  } = shopInfos

  return <Container maxWidth='lg' className={classes.container}>

    <Seo />

    <StaticBreadcrumbs items={breadcrumb} />

    <Typo component='h1' variant='h4' color='inherit' gutterBottom>
      Kontakt - Fragen, Wünsche, Anregungen
    </Typo>

    <Typo component='p' variant='body2' color='inherit' paragraph>
      Wir sind für Sie da, wenn Sie Fragen, Wünsche oder Anregungen für uns
      haben. Gern können Sie auch einen individuellen Termin mit Ihrem
      Fachberater Ihres Vertrauens vereinbaren.
    </Typo>

    <hr />

    <div className={classes.kontaktInfos}>

      <div>
        <Typo component='h2' variant='h6' color='inherit' gutterBottom>
          Adresse:
        </Typo>
        <p>
          {legalname} <br />
          {street}
        </p>
        <p>{postalcode} {locality}</p>
      </div>

      <div>
        <Typo component='h2' variant='h6' color='inherit' gutterBottom>
          So erreichen Sie uns:
        </Typo>
        <p>
          {telephone && <><CallIcon /> {telephone} <br /></>}
          <FaxIcon /> {fax}
        </p>
        <p><AlternateEmailIcon /> {email}</p>
      </div>

    </div>

    <hr />

    <Typo component='h2' variant='h4' color='inherit' gutterBottom>
      Kontaktformular:
    </Typo>

    <Kontaktformular />

  </Container>
}

export default Kontakt
